import * as React from 'react';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import { BusinessSearchModalBase } from '../../../custom_shared/components';
import { BusinessDto } from '../../../custom_shared/types';

const BusinessSearchModal: React.FC = () => {
    const appStore = useAppStore();

    const { tab, businessSearchStore, actionStore } = appStore;

    const { balanceInformationNode } = businessSearchStore;

    if (!balanceInformationNode) {
        return null;
    }

    const { underwritingYearInput, businessIdInput, insuredPeriodStartInput, insuredPeriodEndInput } =
        balanceInformationNode;

    const handleBusinessClick = (business: BusinessDto) => {
        if (!businessIdInput || !insuredPeriodStartInput) {
            return;
        }

        businessIdInput.setValue(business.identifier);
        businessIdInput.invalidateDependentInputsSources();
        insuredPeriodStartInput.invalidateDependentInputsSources();

        const insuredPeriodStart = business.insuredPeriodStart
            ? DateTime.fromJSDate(new Date(business.insuredPeriodStart)).toFormat('yyyy-MM-dd')
            : undefined;

        actionStore.changeBusinessId(balanceInformationNode.worksheetId, balanceInformationNode.id, {
            [insuredPeriodStartInput.id]: insuredPeriodStart
        });

        handleClose();
    };

    const handleClose = () => {
        businessSearchStore.setModalVisible(false);
        businessSearchStore.setBalanceInformationNode(null);
        businessSearchStore.setBusinesses([]);
        businessSearchStore.updatePaging(0, businessSearchStore.pageSize);
    };

    return (
        <BusinessSearchModalBase
            formId={`accounting-statement-business-search-${tab.id}`}
            businessSearchStore={businessSearchStore}
            initialFormValues={{
                underwritingYear: underwritingYearInput?.value,
                insuredPeriodStart: insuredPeriodStartInput?.value,
                insuredPeriodEnd: insuredPeriodEndInput?.value
            }}
            onClose={handleClose}
            onBusinessClick={handleBusinessClick}
        />
    );
};

export default observer(BusinessSearchModal);
